import BulkTransfer from "./BulkTransfer"

export default BulkTransfer
